import { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Loading from '../components/Loading'

export default function Shadow({ children, onShadowRoot, stylesheet, }) {
  const hostRef = useRef(null);
  const [shadowRoot, setShadowRoot] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!hostRef.current || shadowRoot) return;

    const root = hostRef.current.attachShadow({ mode: "open" });
    setShadowRoot(root);

    if (onShadowRoot) onShadowRoot(root);

    // Se não tem stylesheet, já está pronto
    if (!stylesheet) {
      setReady(true);
      return;
    }

    // Criar o link do CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = stylesheet;

    // Quando carregar, libera o conteúdo
    link.onload = () => {
      setReady(true);
    };

    // Em caso de erro, libera mesmo assim (ou trate como quiser)
    link.onerror = () => {
      console.warn("Falha ao carregar stylesheet:", stylesheet);
      setReady(true);
    };

    root.appendChild(link);
  }, [shadowRoot, onShadowRoot, stylesheet]);

  return (
    <>
      {shadowRoot && !ready && <Loading loading={true}/>}
      <div ref={hostRef}>
        {shadowRoot && ready && createPortal(children, shadowRoot)}
      </div>
    </>
  );
}
